import clsx from "clsx";
import s from "./ListItems.module.scss";
import { useRef } from "react";
import React from "react";
interface PropsI {
  list: React.ReactElement[];
  type?: "image" | "text";
}
export const ListItems: React.FC<PropsI> = (props) => {
  const { list, type = "image" } = props;
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  return (
    <div
      className={clsx(s.listItemsContainer, s["list_type_" + type])}
      role="list"
      ref={wrapperRef}
    >
      {list.map((item, index) => (
        <div key={index}>{React.cloneElement(item, { wrapperRef })}</div>
      ))}
    </div>
  );
};
